"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { ShieldPlus, ArrowLeft, Home } from "lucide-react";

export default function NotFound() {
  const t = useTranslations("errors");
  const tc = useTranslations("common");
  const router = useRouter();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4">
      <div className="w-full max-w-lg text-center">
        {/* Brand anchor */}
        <div className="mb-10 flex items-center justify-center gap-2 text-muted-foreground">
          <ShieldPlus className="h-5 w-5 text-primary" />
          <span className="text-sm font-medium tracking-tight">
            {tc("appName")}
          </span>
        </div>

        {/* Large monospace 404 */}
        <div className="mb-6 font-mono text-[8rem] font-bold leading-none tracking-tighter text-primary/10 sm:text-[10rem]">
          404
        </div>

        <h1 className="text-lg font-semibold tracking-tight">
          {t("notFoundTitle")}
        </h1>

        <p className="mx-auto mt-2 max-w-xs text-sm leading-relaxed text-muted-foreground">
          {t("notFoundDescription")}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <Button nativeButton={false} render={<Link href="/app" />}>
            <Home className="mr-1.5 h-4 w-4" />
            {t("goHome")}
          </Button>
          <Button variant="outline" onClick={() => router.back()}>
            <ArrowLeft className="mr-1.5 h-4 w-4" />
            {t("goBack")}
          </Button>
        </div>
      </div>
    </div>
  );
}
